import type {
  TGetFriendsPaginatedParams,
  TGetFriendInfoParams,
  TPaginatedFriendsResponse,
  TFriendInfo,
  TFriendship
} from '@packages/utils/types';
import { CredenzaSDK } from '@credenza3/core-web';

export async function getFriendsPaginated(
  sdk: CredenzaSDK,
  params?: TGetFriendsPaginatedParams
): Promise<TPaginatedFriendsResponse> {
  return await sdk.account.getFriendsPaginated(params);
}

export async function sendFriendRequest(
  sdk: CredenzaSDK,
  targetSub: string,
  clientId?: string
): Promise<TFriendship> {
  return await sdk.account.sendFriendRequest(targetSub, clientId);
}

export async function acceptFriendRequest(
  sdk: CredenzaSDK,
  friendshipId: string
): Promise<TFriendship> {
  return await sdk.account.acceptFriendRequest(friendshipId);
}

export async function blockUser(
  sdk: CredenzaSDK,
  targetSub: string,
  clientId?: string
): Promise<TFriendship> {
  return await sdk.account.blockUser(targetSub, clientId);
}

export async function unblockUser(
  sdk: CredenzaSDK,
  targetSub: string,
  clientId?: string
): Promise<TFriendship> {
  return await sdk.account.unblockUser(targetSub, clientId);
}

export async function removeFriend(
  sdk: CredenzaSDK,
  targetSub: string,
  clientId?: string
): Promise<TFriendship> {
  return await sdk.account.removeFriend(targetSub, clientId);
}

export async function getFriendInfo(
  sdk: CredenzaSDK,
  targetSub: string,
  params?: TGetFriendInfoParams
): Promise<TFriendInfo> {
  return await sdk.account.getFriendInfo(targetSub, params);
}
